import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { CalendarEvent } from "../../types";
import { toHHMMSS } from "../../screens/ClientVideo";

type Props = {
  events: CalendarEvent[];
  mt?: string;
};

const getEventPlayedSeconds = (event: CalendarEvent) => {
  return event.extendedProps.type === "reservation"
    ? ""
    : event.extendedProps.log
    ? toHHMMSS(event.extendedProps.log.playedSeconds)
    : toHHMMSS(0);
};

export const EventsTable: React.FC<Props> = ({ events, mt }) => {
  const { t } = useTranslation();

  console.log(events);

  return (
    <Table variant="simple" size="lg" mt={mt}>
      <Thead bg={"#F0F2F4"} flex={1}>
        <Tr bg={"#F0F2F4"}>
          <Th color={"#7B8395"}>{t("screens.client.activitiesTable.date")}</Th>
          <Th color={"#7B8395"}>{t("screens.client.activitiesTable.type")}</Th>
          <Th color={"#7B8395"}>{t("screens.client.activitiesTable.name")}</Th>
          <Th color={"#7B8395"}>
            {t("screens.client.activitiesTable.duration")}
          </Th>
        </Tr>
      </Thead>
      <Tbody>
        {events.map((event) => (
          <Tr>
            <Td>{new Date(event.start).toLocaleDateString()}</Td>
            <Td>
              {event.extendedProps.type === "reservation"
                ? "Prenotazione"
                : event.extendedProps.category || event.extendedProps.type}
            </Td>
            <Td>{event.title}</Td>
            <Td>{getEventPlayedSeconds(event)}</Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};
